// Falling pressure ahead of a front is a more reliable angling signal than
// the absolute reading, so we compare "now" to the next 3-hour forecast step.
export function getPressureTrend(currentPressure, forecastData) {
  const nextStep = forecastData?.list?.[0];
  if (!nextStep) return "steady";
  const delta = nextStep.main.pressure - currentPressure;
  if (delta <= -1) return "falling";
  if (delta >= 1) return "rising";
  return "steady";
}
